import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toasty } from '@cloudflare/kumo'
import { Auth0Provider } from './auth/Auth0Provider'
import { LanguageProvider } from './i18n'
import { App } from './App'
import './app.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <Auth0Provider>
        <LanguageProvider>
          <Toasty>
            <App />
          </Toasty>
        </LanguageProvider>
      </Auth0Provider>
    </BrowserRouter>
  </StrictMode>,
)
